import React from "react"
import {Link} from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebookF, faGithub,faLinkedinIn} from '@fortawesome/free-brands-svg-icons'
import Typist from 'react-typist';

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false

const Body = () => (
  <div className="row">
    <div className="body-container title-heading">
          <ul className="list-inline social">
            <li className="list-inline-item"><a href="https://github.com/mechiragjain" target="_blank"><span><FontAwesomeIcon className="social-icons changeOn" icon={faGithub} size={1} /></span></a></li>
            <li className="list-inline-item"><a href="https://www.linkedin.com/in/mechiragjain/" target="_blank"><span><FontAwesomeIcon className="social-icons changeOn" icon={faLinkedinIn} size={1} /></span></a></li>
            <li className="list-inline-item"><a href="https://www.facebook.com/hungamadealchirag" target="_blank"><span><FontAwesomeIcon className="social-icons changeOn" icon={faFacebookF} size={1} /></span></a></li>
            <li className="list-inline-item"><a href="https://www.instagram.com/me.chiragjain/" target="_blank"><span><FontAwesomeIcon className="social-icons changeOn" icon={faInstagram} size={1} /></span></a></li>
          </ul>
          <div>
            <h2> 👋 Hey,</h2>
            <h1 className="name-heading"><Typist cursor={{show: false}}>I'm Chirag Jain</Typist></h1>
            <p className="about-heading">Experienced founder with demonstrated skills in Web Development and Marketing</p>

            <ul class="list-inline">
            <li className="list-inline-item icon-heading"><Link to="https://hungamadeal.co.in" style={{color:"white",textDecoration:"none",target:"_blank"}}>Hungama Deal</Link></li>

            {/* <li className="list-inline-item icon-heading"><a href="https://hungamadeal.co.in" target="_blank"><FontAwesomeIcon className="social-icons changeOn" icon={faLink} /></a></li> */}
            </ul>

          </div>
    </div>
  </div>
)

// Header.propTypes = {
//   siteTitle: PropTypes.string,
// }
//
// Header.defaultProps = {
//   siteTitle: ``,
// }

export default Body
